export const USERNAME = (value) =>({type:"username", payload: value})
export const PASSWORD = (value) =>({type:"password", payload: value})